import React from 'react';

import { Grid } from '@material-ui/core';
import { StyledGrid, StyledBorderedPaper } from 'styles/common';

import { CHARTS_PADDING } from 'constants/ProjectConstants';

import { useGoalAnalytics } from '../GoalAnalyticsContext';
import ProgressCheckinChart from '../GoalObjective/ProgressCheckinChart';
import GoalStatusChart from '../GoalStatusChart';
import GoalsList from '../GoalsList';
import EmployeeCheckinAndProgressChart from './EmployeeCheckinAndProgressChart';
import EmployeeStatsTable from './EmployeeStatsTable';
import TopAndLeastPerformantEmployeeChart from './TopAndLeastPerformantEmployeeChart';

/**
 * @deprecated 06-08-2024
 */
const GoalIndividual = ({ isWithGraphs = true, isVerV1 = false }) => {
  const {
    state: { selectedView },
  } = useGoalAnalytics();

  const { expandedRowDetails } = selectedView;
  const { infoObj } = expandedRowDetails || null;
  return (
    <>
      {isWithGraphs && (
        <Grid container alignItems="stretch">
          <StyledGrid paddingRight={CHARTS_PADDING} item xs={6}>
            {infoObj ? <ProgressCheckinChart /> : <EmployeeCheckinAndProgressChart />}
          </StyledGrid>
          <StyledGrid paddingLeft={CHARTS_PADDING} item xs={6}>
            {infoObj ? <GoalStatusChart parentUuid={infoObj.uuid} /> : <TopAndLeastPerformantEmployeeChart />}
          </StyledGrid>
        </Grid>
      )}
      <StyledBorderedPaper overFlow="auto" marginBottom="2rem" padding="0" topGutter={2}>
        {infoObj ? <GoalsList employeeId={infoObj.uuid} /> : <EmployeeStatsTable />}
      </StyledBorderedPaper>
    </>
  );
};

export default GoalIndividual;
